import * as React from "react";
function SvgEnvelope(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M45.3 8H2.7C1.2 8 0 9.2 0 10.7v26.7C0 38.8 1.2 40 2.7 40h42.7c1.5 0 2.7-1.2 2.7-2.7V10.7C48 9.2 46.8 8 45.3 8zm-1.9 2.7L24 23.7l-19.1-13h38.5zM18.5 23.2L2.7 36.6V12.4l15.8 10.8zM5.9 37.3l14.8-12.6 3.3 2.2 3.3-2.2 15.8 12.6H5.9zm39.4-1.6L29.6 23.1l15.7-10.6v23.2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgEnvelope);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
